import { Vue } from 'ui.vue';
import ShopList from "./shop-list.vue";

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.shops-list').forEach((element) => {
		Vue.create({
			el: element,
			template: `
				<shop-list
					:defaultCity="defaultCity"
					:shops="shops"
					:cities="cities"
					:showCityFilter="showCityFilter"
					:showFullMap="showFullMap"
					:showAllCities="showAllCities"
					:showFeatureFilter="showFeatureFilter"
					:showInCatalogBtn="showInCatalogBtn"
					:showInCatalogUrl="showInCatalogUrl"
				/>
			`,
			data: () => {
				return {
					...{
						defaultCity: undefined,
						shops: undefined,
						cities: undefined,
						showCityFilter: undefined,
						showFullMap: undefined,
						showAllCities: undefined,
						showFeatureFilter: undefined,
						showInCatalogBtn: undefined,
						showInCatalogUrl: undefined,
					},
					...JSON.parse(document.querySelector(`#${element.dataset.dataId}`).innerHTML)
				}
			},
			components: {
				'shop-list': ShopList,
			}
		});
	});
});
